import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DateTime } from './datetime';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { PopoverModule } from '../ngx-bootstrap/popover';
import { DateInputKeyboardHandlerDirective } from '../../directives/helper/datetime-keyboard-handler.directive';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    PopoverModule.forRoot(),
    DateInputKeyboardHandlerDirective
  ],
  declarations: [DateTime], // Declare the component here
  exports: [DateTime] // Export it for other modules to use
})
export class DateTimeModule { }